import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "product-management",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const productManagement = require("./ProductManagement").default;
          cb(null, productManagement);
        },
        "ProductManagement"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/ProductManagement/index.js